import { PlusOutlined } from '@ant-design/icons'
import type { ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'

import generalCn from '../OrganisationsSearch.module.scss'

interface OrganisationCreationProps {
  trigger?: { className: string; icon: ReactNode; label: string }
}

function OrganisationCreation({ trigger }: OrganisationCreationProps) {
  const navigate = useNavigate()
  const openRegistration = () => navigate('/register')

  return trigger ? (
    <button
      type="button"
      className={trigger.className}
      aria-label={trigger.label}
      title={trigger.label}
      onClick={openRegistration}
    >
      {trigger.icon}
    </button>
  ) : (
    <button className={generalCn.button} onClick={openRegistration}>
      <div>
        <PlusOutlined />
      </div>
    </button>
  )
}

export default OrganisationCreation
